/** Caché sessionStorage para pools del hero (misma idea que colivingHubListCache). */
const STORAGE_PREFIX = 'cl_hero_pool_v1'
/** Alineado con hub list (5 min) — datos frescos sin martillar searchProperties. */
const TTL_MS = 5 * 60 * 1000

function storageKey(region, lang, cityId) {
  return `${STORAGE_PREFIX}:${region || 'es'}:${(lang || 'es').slice(0, 2)}:${cityId}`
}

export function readHeroFeaturedPoolCache(region, lang, cityId) {
  if (typeof sessionStorage === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(storageKey(region, lang, cityId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed?.savedAt || !Array.isArray(parsed.pool)) return null
    if (Date.now() - parsed.savedAt > TTL_MS) return null
    return parsed
  } catch {
    return null
  }
}

export function writeHeroFeaturedPoolCache(region, lang, cityId, pool) {
  if (typeof sessionStorage === 'undefined' || !cityId || !pool?.length) return
  try {
    sessionStorage.setItem(
      storageKey(region, lang, cityId),
      JSON.stringify({
        savedAt: Date.now(),
        pool,
      }),
    )
  } catch {
    /* quota / private mode */
  }
}
